import {trackPromise} from "react-promise-tracker";
import CallV2 from "../../service/axiosV2";
import {getUrl} from "../../constants/urls";

export const getWebhooksAsync = (pageUrl) => {
  const url = pageUrl ? pageUrl : getUrl("listWebHooks");
  return trackPromise(CallV2.get(url));
};

export const createUpdateWebhookAsync = (data = {}) => {
  const {id = ""} = data;
  const url = getUrl("listWebHooks");
  if (id) {
    const patchUrl = `${url}${id}/`;
    return trackPromise(CallV2.patch(patchUrl, data));
  } else {
    return trackPromise(CallV2.post(url, data));
  }
};

export const deleteWebhookAsync = (id = "") => {
  const url = getUrl("listWebHooks");
  const deleteUrl = `${url}${id}/`;
  return trackPromise(CallV2.delete(deleteUrl));
};

export const getWebhookDeliveryLogsAsync = (pageUrl, webhookId) => {
  const url = pageUrl ? pageUrl : getUrl("listWebhookDeliveryLogs")(webhookId);
  return trackPromise(CallV2.get(url));
};
